<template>
  <div class="wait-for-handle-card">
    <div class="info-container">
      <div class="info-line">
        <div class="info-column">
          <div v-if="data.plateNo" class="info-right-split">
            <span class="info-plateNo">{{ data.plateNo }}</span>
            <BLM-copy-button :text="data.plateNo">
              <i class="el-icon-document-copy" />
            </BLM-copy-button>
          </div>
          <div class="info-id info-right-split">车辆ID：{{ data.id }}</div>
          <div class="info-tags">
            不可租标签：
            <template v-if="data.nonRentableTagList">
              <el-tag
                v-for="(item, index) in data.nonRentableTagList.slice(0, 5)"
                size="large"
                :key="index"
              >
                {{ item }}
              </el-tag>
              <el-tag size="large" v-if="data.nonRentableTagList.length > 5">
                +{{ data.nonRentableTagList.length - 5 }}
              </el-tag>
            </template>
            <i class="el-icon-edit" v-if="isCompany" @click="handleEditTag()"></i>
          </div>
        </div>
        <div class="info-column">
          <el-button
            type="text"
            style="margin-right: 12px"
            @click="foldClick"
          >{{ fold ? '展开' : '合起' }}</el-button>
          <Combine-buttons :showNum="200" :list="buttonList" :query="data"/>
        </div>
      </div>
      <div class="info-line">
        <div class="info-column">
          <div class="info-right-split">{{ data.modelName || '--' }}</div>
          <div class="info-right-split">
            <span>VIN码：{{ data.vin }}</span>
            <BLM-copy-button :text="data.vin">
              <i class="el-icon-document-copy" />
            </BLM-copy-button>
          </div>
          <div>发动机号：{{ data.engineNo || '--' }}</div>
        </div>
      </div>
      <div class="info-line">
        <div class="info-column">
          <div class="info-right-split">在库时长{{ Number(data.inventoryTime) === 0 ? 0 : (data.inventoryTime || '--') }}天</div>
          <div v-if="!isCompany" class="info-right-split">{{ data.companyName || '--' }}</div>
          <div class="info-right-split">车管：{{ data.userName || '--' }}</div>
          <div>调拨状态：{{ transferStateMap[data.transferState] || '--' }}</div>
        </div>
      </div>
    </div>
    <div class="todo-container" v-if="!fold">
      <div class="todo-item" v-for="(item, index) in groupTypeList" :key="index">
        <div class="todo-item-title">{{ item.groupTypeName }}</div>
        <div v-for="(it, i) in item.details" :key="i">
          <div
            :class="['todo-item-text', {'clickable': it.itemState !== 2 }]"
            @click="todoClick(it)"
          >{{ it.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, watchEffect, computed } from 'vue'
import { useRouter, useStore, usePermission } from '@/utils/useUtils'
import CARDICT from '@/store/dict/carDict.js'
import { operationUtils, goTodo } from '../config/index'
import { OPERATES } from '../config/waitForHandle'

const emit = defineEmits(['lookCarDetail', 'editCar', 'outCar', 'returnCar', 'careCar', 'fixCar', 'accidentCar', 'prepareCar', 'addInsure', 'addLicense', 'confirmCarInStore', 'dealCar', 'cancelPrepareCar', 'carInfoSubmit', 'editUnRentableTags'])

// 车辆调拨状态枚举
const transferStateMap = ref(CARDICT.VEHICLE_TRANSFER_STATE())

const router = useRouter()
const store = useStore()
const permission = usePermission()

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
})

// 折叠卡片
const fold = ref(false)
const foldClick = () => {
  fold.value = !fold.value
}

const isCompany = computed(() => store.state.user?.userInfo?.sessionCompanyId)

const groupTypeList = ref({
  1: {
    groupTypeName: '事故',
    details: [],
  },
  2: {
    groupTypeName: '维保',
    details: [],
  },
  3: {
    groupTypeName: '违章',
    details: [],
  },
  4: {
    groupTypeName: '保险',
    details: [],
  },
  5: {
    groupTypeName: '证照',
    details: [],
  },
})

const operations = operationUtils(permission, router, {
  careCarKey: 'vehicle_maintenance_list_create',
  fixCarKey: 'vehicle_maintenance_list_create',
  accidentCarKey: 'vehicle_accident_list_create',
  addLicenseKey: 'vehicle_licences_list_create',
})

// 点击待办
const todoClick = goTodo(router, props.data)

const buttonList = computed(() => {
  const ops = []
  OPERATES.forEach((i) => {
    const op = operations[i]
    if (!op.judgePermission || op.judgePermission(props.data)) {
      ops.push({
        name: i,
        label: op.label,
        action: () => emit(i, props.data),
      })
    }
  })
  return ops
})

// 点击编辑不可租标签
const handleEditTag = () => {
  emit('editUnRentableTags', props.data)
}

watchEffect(() => {
  for (const key in groupTypeList.value) {
    if (Object.hasOwnProperty.call(groupTypeList.value, key)) {
      groupTypeList.value[key].details = []
    }
  }
  Array.isArray(props.data.cardItems) && props.data.cardItems.forEach((item) => {
    groupTypeList.value[item.groupType].details.push(item)
  })
})
</script>
<script>
export default {
  name: 'WaitForHandleCard',
}
</script>
<style lang="scss" scoped>
.wait-for-handle-card {
  width: 100%;
  border: 1px solid #DCDFE6;
  margin-bottom: 8px;
  border-radius: 4px;
  .info-container {
    padding: 16px;
    .info-plateNo {
      position: relative;
      font-size: 20px;
      font-weight: 500;
      color: #303133;
      &::before {
        display: inline-block;
        content: "";
        position: absolute;
        width: 2px;
        height: 16px;
        background: #276bec;
        top: 4px;
        left: -6px;
      }
    }
    .info-tags {
      .el-icon-edit{
        color: #276BEC;
        cursor: pointer;
      }
      ::v-deep .el-tag {
        margin-right: 8px;
      }
    }
    .info-line {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 8px;
      &:last-child {
        margin-bottom: 0;
      }
      .info-column {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        text-wrap: nowrap;
        .info-right-split {
          margin-right: 24px;
          position: relative;
          &::after {
            position: absolute;
            content: "";
            width: 1px;
            height: 14px;
            background: #d8d8d8;
            top: 4px;
            right: -12px;
          }
        }
      }
    }
  }
  .todo-container {
    border-top: 1px solid #DCDFE6;
    border-radius: 4px;
    background-color: #f5f7fa;
    padding: 16px 36px;
    display: flex;
    justify-content: space-between;
    .todo-item {
      .todo-item-title {
        position: relative;
        color: #3d3d3d;
        margin: 4px;
        &::before {
          display: inline-block;
          content: "";
          position: absolute;
          width: 2px;
          height: 12px;
          background: #276bec;
          top: 4px;
          left: -8px;
        }
      }
      .todo-item-text {
        color: #8e9299;
        padding: 2px 8px;
        display: inline-block;
        &.clickable {
          cursor: pointer;
          color: #276BEC;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          &:hover{
            background: #276BEC;
            color: #fff;
            border-radius: 4px;
          }
        }
      }
    }
  }
}
</style>
